export default {
  black: '#141414',
  brand: '#3CA091',
  'brand-lighten': '#A0E6DC',
  'brand-lighten-1': '#E6FAFA',
  error: '#FF5050',
  info: '#4B78F0',
  success: '#00A05F',
  warning: '#FFAA32',
  grey: '#DCDCDC',
  'grey-lighten': '#F0F0F0',
  'grey-lighten-1': '#FAF8F8',
  'grey-darken': '#BEBEBD',
  'grey-darken-1': '#757575'
};
